<div class="contractor-upload">
  <div class="dark-blue">
    <nestas-toolbar [steps]="[]"></nestas-toolbar>
  </div>

  <div class="wrap" [ngStyle]="{'margin-top' : (isPhone) ? '-70px' : '0', 
  'margin-left' : (isPhone) ? '15px' : 'auto'}">

    <div *ngIf="isPhone && fileTable && tabindex ==0" class="tabselectoricons">
      <a (click)="fileTable.showfilters = false"><img class="cards" src="/assets/listicon2.png" height="30"
          style="z-index:1">
      </a>
      <div class="mobileonly sortfilt" [ngStyle]="{'opacity' : (fileTable.showfilters) ? 0.5 : 1}">
        <span>
          <a (click)="filterOnOff()">{{translate.instant('BUTTON.ACTION.FILTER')}}</a>
          <!--<a (click)="tabindex = 1;">sorteren</a>-->
        </span>
      </div>
    </div>

    <mat-tab-group #tabGroup class="mat-tab-group" [(selectedIndex)]="tabindex" (selectedTabChange)="onTabChanged($event);">

      <mat-tab>

        <ng-template mat-tab-label>
          {{translate.instant('DATA.MY_FILES')}}
          <span class="material-icons-badge material-icons-badge-margin"
            *ngIf="requestedfiles.length > 0">{{requestedfiles.length}}</span>
        </ng-template>

        <nestas-file-table #fileTable *ngIf="table.requestedfiles.all.length && file" [files]="table.requestedfiles"
          [pending]="table.pending" [onClick]="goToUpload" editable="true" [forContractor]="true" [pid]="file.PID"
          [compact]="isPhone" [showfilters]="!isPhone">
        </nestas-file-table>
      </mat-tab>


      <mat-tab>

        <ng-template mat-tab-label>
          {{translate.instant('DATA.SHARED_WITH_ME')}}
          <span class="material-icons-badge material-icons-badge-margin"
            *ngIf="linkedfiles.length > 0">{{linkedfiles.length}}</span>
        </ng-template>

        <nestas-file-table #sharedFileTable *ngIf="table.linkedfiles.all.length" [files]="table.linkedfiles"
          [compact]="isPhone" [showfilters]="!isPhone" [pending]="table.pending" [onClick]="goToLinkedFile"
          editable="true" [forContractor]="true" [filtered]="false">
        </nestas-file-table>
      </mat-tab>



      <mat-tab>

        <div style="margin-top: 40px;" [ngStyle]="{'margin-left' : (isPhone) ? '-15px' : '0'}">

          <ng-template mat-tab-label>
            {{translate.instant('CONTRACTOR_UPLOAD.FILE_SUMMARY')}}
          </ng-template>


          <mat-card *ngIf="error" align="center">
            <div class="mat-card-wrapper">
              <div mat-card-image>
                <i class="material-icons red">error</i>
              </div>
              <mat-card-title>{{translate.instant(error)}}</mat-card-title>
            </div>
          </mat-card>

          <mat-card *ngIf="success" align="center">
            <div class="mat-card-wrapper">

              <mat-card-title>
                <div>
                  <i class="material-icons green">check_circle</i>
                  <span
                    style="vertical-align: middle;padding-bottom:50px;margin-left:10px;">{{translate.instant('CONTRACTOR_UPLOAD.FILES_UPLOADED')}}</span>
                    <div style="margin-left:74px" *ngFor="let file of filesUploaded; index as i">
                      {{file.name}}
                    </div>
                  <div style="margin-left:74px;margin-top:20px;margin-bottom:40px">{{translate.instant('MESSAGE.THANK_YOU')}} !</div>
                  
                </div>
              </mat-card-title>
            
            </div>
          </mat-card>


          <!--<div *ngIf="success" style="max-width: 1010px; margin-bottom: 40px;" class="alert-info">
            <i class="material-icons green">check_circle</i>
            <div>{{translate.instant('CONTRACTOR_UPLOAD.FILES_UPLOADED')}}</div>
            <br />
            <br />
            <div>{{translate.instant('MESSAGE.THANK_YOU')}} !</div>
          </div>-->


          <div *ngIf="file && file.PID && !working">
            <div class="display-flex">
              <div [ngStyle]="{'margin-bottom' : (isPhone) ? '240px' : '80px'}">
                <mat-card class="file-summary">
                  <mat-card-title>{{translate.instant('CONTRACTOR_UPLOAD.FILE_SUMMARY')}}</mat-card-title>

                  <div style="margin-top: 40px">
                    <span *ngIf="file.notifications" class="highlight">
                      <span *ngIf="file.notifications.length">{{translate.instant('DATA.NOTIFICATIONS')}}:</span><span
                        *ngIf="!file.notifications.length">{{translate.instant('DATA.NO_NOTIFICATIONS')}}</span>
                    </span><br />

                    <div *ngFor="let n of file.notifications">
                      {{translate.instant('DATA.' + n.frequency.toUpperCase())}}: {{n.topic}}
                    </div>
                  </div>
                  <br />

                  <div class="version" *ngIf="file.versions">
                    <span class="highlight">{{translate.instant('DATA.VERSIONS')}}:</span>
        
                    <div *ngFor="let v of file.versions" class="versions">
                      <a [ngClass]="{'active' : versionId == v._id}"
                        (click)="goToUpload(file, v._id)">{{v.date | date: 'dd/MM/yyyy - H:mm:ss'}}</a>
                        
                    </div>
        
                  </div>
                  <br />
                  <div>
                    <!--<div><span class="highlight">{{translate.instant('DATA.NAME')}}:</span><br />{{file.name}}</div>
                    <br />-->
                    <div>
                      <span class="highlight">{{translate.instant('DATA.OWNER')}}:</span><br />
                      {{file.PID.PIDOwner.name}}<br />
                    </div>
                    <br />
                    <div><span
                        class="highlight">{{translate.instant('DATA.ADDRESS')}}:</span><br />{{file.PID.address.address}}<br
                        *ngIf="file.PID.address.zip || file.PID.address.city" /> {{file.PID.address.zip}}
                      {{file.PID.address.city}}
                    </div>
                    <br />
                    <div *ngIf="file.job"><span
                        class="highlight">{{translate.instant('DATA.JOB')}}:</span><br />{{file.job}}</div>
                    <br *ngIf="file.job" />
                    <!--
                    <div><span class="highlight">{{translate.instant('DATA.TYPE')}}:</span><br /> {{file.type}}</div>
                    <br />
                    <div><span class="highlight">{{translate.instant('DATA.ROOM')}}:</span><br /> {{file.room}}</div>
                    <br />
                    <div><span class="highlight">{{translate.instant('DATA.DESCRIPTION')}}:</span><br />
                      {{file.description}}
                    </div>
                    
                    <br />
                    <div *ngIf="file.contractor"><span
                        class="highlight">{{translate.instant('DATA.CONTRACTOR')}}:</span><br />
                      {{file.contractor.name}}
                    </div>
                    <br />
                  -->
                  </div>
                  <br />


                  <mat-card-title>Nestas contact info</mat-card-title>
                  <contact></contact>
                  <mat-card class="messageboxfd" style="margin:0;margin-top:10px" [style.width]="getMessageWidth()"
                    [style.padding]="getMessagePadding()">
                    <div (click)="openMessages = !openMessages" class="cursor">
                      <div *ngIf="!openMessages" class="alert-info alert-info-reverse">
                        <i [title]="translate.instant('DATA.CONTACT_OWNER')" class="material-icons ic-info">message</i>
                        {{translate.instant('DATA.CONTACT_OWNER')}}
                      </div>
                      <div *ngIf="openMessages" class="close-box">
                        <span><i class="material-icons">close</i></span>
                      </div>
                    </div>
                    <div *ngIf="openMessages">
                      <mat-card-subtitle>{{translate.instant('DATA.MESSAGES')}}</mat-card-subtitle>
                      <message [messages]="messages" (send)="sendMessage($event)"></message>
                    </div>
                  </mat-card>
                </mat-card>

              </div>



              <mat-card class="card-drop full-width" [ngStyle]="{'margin-top' : (isPhone) ? '-55px' : '0'}">
                <div *ngIf="working" class="working-background">
                  <mat-progress-spinner mode="indeterminate" class="spinner"></mat-progress-spinner>
                </div>

                <!-- File table -->

                <ngx-datatable *ngIf="fileViewUrls" class="bootstrap" [rows]="[file]" [rowHeight]="getHeight()"
                  [headerHeight]="getHeaderHeight()" [messages]="{emptyMessage: translate.instant('DATA.NO_DATA')}"
                  [ngStyle]="{'margin-bottom' : (isPhone) ? '25px' : '0'}">

                  <ngx-datatable-column *ngIf="!isPhone" name="Status" [width]="67" [sortable]="true"
                    [comparator]="statusComparator" prop="locked">

                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <div>
                        <img alt="{{status}}" class="logo" src="{{status2imgfn(getStatus(row))}}"
                          style="height:64px;padding:12px;padding-left:4px;padding-right:10px" />
                      </div>
                    </ng-template>

                  </ngx-datatable-column>

                  <ngx-datatable-column *ngIf="!isPhone" name="{{translate.instant('DATA.PID')}}" [width]="130"
                    [sortable]="true" prop="PID.name" [comparator]="comparator">

                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <div class="divider left-divider">
                        <div class="content">
                          <div>{{row.PID.name}}<br />
                            {{row.PID.address && row.PID.address.city}}
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column *ngIf="!isPhone" name="{{translate.instant('DATA.PARENTPID')}}" [width]="130"
                    [sortable]="true" prop="PID.parentPID" [comparator]="comparator">

                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <div class="divider">
                        <div class="content">
                          <div>{{row.PID.parentPID && row.PID.parentPID.name}}<br />
                            {{row.PID.parentPID && row.PID.parentPID.address && row.PID.parentPID.address.city}}
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="{{translate.instant('DATA.NAME')}}" [width]="getWidth('name')"
                    [sortable]="true" prop="name" [comparator]="comparator">

                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <div class="divider" [ngClass]="{'left-divider' : isPhone}"
                        [ngStyle]="{'height': (isPhone) ? '92px' : '64px'}">
                        <div class="content">
                          <!--ellipsis-->
                          {{row.name}}
                          <div *ngIf="isPhone">
                            <div class="subcontent1L">{{row.type}}</div>
                            <div class="subcontent1L">{{row.description}}</div>
                            <div class="subcontent1L">{{row.deadline}}</div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column *ngIf="!isPhone" name="{{translate.instant('DATA.TYPE')}}" [width]="160"
                    [sortable]="true" prop="metaType" [comparator]="comparator">

                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <div class="divider" [ngStyle]="{'height': (isPhone) ? '92px' : '64px'}">
                        <div class="content">{{row.type}}</div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column *ngIf="!isPhone" name="{{translate.instant('DATA.DESCRIPTION')}}" [width]="200"
                    [sortable]="true" prop="description" [comparator]="comparator">

                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <div class="divider">
                        <div style="height: 50px" class="content">
                          {{row.description}}
                        </div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column *ngIf="0 && !isPhone" name="{{translate.instant('DATA.DEADLINE_TABLE')}}"
                    [width]="100" [sortable]="true" prop="deadline" [comparator]="comparator">

                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <div class="divider">
                        <div class="content center">
                          <div>{{row.deadline | date: 'dd/MM/yyyy'}}</div>
                        </div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>


                <!-- / File table -->

                <div [ngStyle]="{'margin-bottom' : (isPhone) ? '240px' : '80px'}">
                  <div *ngIf="!file.locked && putToken" style="margin-top: 20px" class="alert-info">
                    <i class="material-icons ic-info">info</i>
                    {{translate.instant('CONTRACTOR_UPLOAD.INSTRUCTIONS')}}
                  </div>
                  <table class="full-width">
                    <tr class="upload-flex">
                      <td *ngIf="!file.locked  && putToken">
                        <div #dropzone class="drop-zone full-width" (dragover)="dragover(dropzone)"
                          (dragend)="dragend(dropzone)" (drop)="drop($event, dropzone)">
                          <div>
                            <div class="title">
                              <i class="material-icons ic-file">insert_drive_file</i><br />
                              {{translate.instant('CONTRACTOR_UPLOAD.DRAG_DROP')}}<br />
                              <span class="subtitle">
                                {{translate.instant('CONTRACTOR_UPLOAD.A_FILE_HERE')}}
                                <input class="file-button" type="file" name='file' id='file'
                                  (change)="fileChangeEvent($event)" multiple />
                              </span>
                            </div>
                          </div>
                        </div>
                        <button mat-raised-button [disabled]="working || file.locked" (click)="uploadFile()"
                          color="primary" class="btn-action">{{translate.instant('BUTTON.ACTION.SEND_FILE')}}
                        </button>
                        <br />
                      </td>
                      <td *ngIf="file.locked  && putToken">
                        <div class="alert-info">
                          <i class="material-icons ic-info">info</i>
                          {{translate.instant('CONTRACTOR_UPLOAD.FILE_LOCKED')}}
                        </div>
                      </td>
                      <td *ngIf="fileViewUrls.length > 0 && !file.locked  && putToken">
                        <div class="alert-warning">
                          <i class="material-icons ic-warning">warning</i>
                          {{translate.instant('CONTRACTOR_UPLOAD.OVERWRITE')}}
                        </div>
                      </td>
                      <td *ngIf="filesToUpload.length > 0" style="border-top:solid 1 px black;">
                        <h3>{{translate.instant('CONTRACTOR_UPLOAD.NEW_FILES')}} ({{filesToPreview.length}})</h3>
                      </td>
                      <div *ngFor="let upload of filesToUpload; let i=index">
                        <input name="upload_{{i}}" [(ngModel)]="filesToUpload[i].upload" type="checkbox">{{upload.file.name}}
                      </div>

                      <td [hidden]="!filesToPreview">
                        <preview *ngIf="filesToPreview && filesToPreview.length" [files]="filesToPreview"></preview>
                      </td>

                      <td *ngIf="fileViewUrls.length > 0" style="border-top:solid 1 px black;">
                        <h3>{{translate.instant('CONTRACTOR_UPLOAD.EXISTING_FILES')}}</h3>
                      </td>
                      <td [hidden]="!fileViewUrls">
                        <preview *ngIf="fileViewUrls && fileViewUrls.length" [files]="fileViewUrls"></preview>
                      </td>
                    </tr>
                  </table>
                </div>
              </mat-card>


            </div>

          </div>
        </div>
      </mat-tab>

    </mat-tab-group>

  </div>
</div>